import {Component, OnInit, ViewContainerRef} from "@angular/core";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {DetalleParametrizacionService} from "../configuracion/services/detalle-parametrizacion.service";
import {FuncionalidadService} from "../seguridad/services/funcionalidad.service";
import {UsuarioService} from "../seguridad/services/usuario.service";
import {Usuario} from "../seguridad/models/usuario.model";
import {DetalleParametrizacionEnum} from "../shared/comun/utils/enums";
import {MediaChange, ObservableMedia} from "@angular/flex-layout";
import {Subscription} from "rxjs";
import {Empresa} from "../core/models/empresa.model";
import {Funcionalidad} from "../seguridad/models/funcionalidad.model";
import {EmpresaService} from "../core/services/empresa.service";
import {DialogService} from "../shared/comun/services/dialog.service";
import {PuntoEmision} from "../recaudacion/models/punto-emision.model";
import {computeStyle} from "@angular/animations/browser/src/util";

@Component({
    moduleId: module.id,
    selector: 'home',
    templateUrl: './home.component.html'
})

export class HomeComponent implements OnInit {

    public empresa: Empresa;
    public usuario: Usuario;
    public funcionalidades: Funcionalidad[];
    public cargando:boolean=false;
    private watcher: Subscription;
    isOpen = true;
    mode = 'side';
    estilo = 'width-20 sidebar-left';

    constructor(private router: Router,
                 private detalleParametrizacion: DetalleParametrizacionService,
                 private viewContainerRef: ViewContainerRef,
                 public translate: TranslateService,
                 private media: ObservableMedia,
                 private funcionalidadService: FuncionalidadService,
                 private usuarioService: UsuarioService,
                 private empresaService:EmpresaService,
                 private dialogService: DialogService) {

        let token = window.localStorage.getItem('auth_key')
        let empresa = this.empresaService.storage_get_empresa();

        if (token != null && empresa!=null) {

            // si el usuario tiene acceso a la empresa
            this.empresaService.getEmpresa(token, empresa.codigo).subscribe(res => {

                this.empresa = res.data
                this.empresaService.storage_set_empresa(res.data);

                this.getUsuarioLogueado();
                this.cargarConfiguraciones();
                this.cargarFuncionalidadesGroup();
                this.router.navigate(['home/dashboard']);

            }, (err) => {
                let mensaje = err.error && err.error.detail ? err.error.detail : err.statusText;
                this.dialogService.notificacion('ERROR!', mensaje , this.viewContainerRef).subscribe(res => {
                    this.logout();
                })
            })

        } else {
            this.router.navigate(['login'])
        }
        this.watcher = media.subscribe((change: MediaChange) => {
            let isMobile = (change.mqAlias == 'xs') || (change.mqAlias == 'sm');
            this.isOpen = !isMobile;
            if (isMobile) {
                this.mode = 'over';
                this.estilo = ''
            }else {
                this.mode = 'side';
                this.estilo = 'width-20 sidebar-left';
            }
        });
    }

    ngOnInit() {
    }


    /**
     * @desc Función que obtiene datos de inicio
     * relacionado a la configuración de las tablas
     */
    cargarConfiguraciones() {
        var token = window.localStorage.getItem('auth_key')
        this.detalleParametrizacion.getDetalleParametrizacionPorCodigo(token, DetalleParametrizacionEnum.ROWS_TABLE)
            .subscribe(res => {
            if (res.status == 200 && res.data) {
                localStorage.setItem(DetalleParametrizacionEnum.ROWS_TABLE, res.data.valor)
            }
        })
    }

    /* @desc Función que obtiene las funcionalidades
     * habilitadas para el usuario y que son presentadas
     * en el menu principal
     */
    cargarFuncionalidadesGroup() {
        var token = window.localStorage.getItem('auth_key')
        this.funcionalidadService.getFuncionalidadesAccesoUsuario(token).subscribe(datos => this.funcionalidades = datos);
    }

    /**
     * @desc Función que obtiene datos del usuario que
     * esta actualmente logeado
     */
    getUsuarioLogueado() {
        var token = window.localStorage.getItem('auth_key')
        this.usuarioService.getUsuarioLogueado(token).subscribe(data => this.usuario = data);

    }

    /**
     * @desc Función que finaliza el inicio de sesión
     * del usuario
     */
    logout() {
        window.localStorage.removeItem('auth_key')
        window.localStorage.removeItem('puntoEmisionUaa')
        window.localStorage.removeItem(DetalleParametrizacionEnum.ROWS_TABLE)
        this.empresaService.storage_delete_empresa();

        this.router.navigate(['']);
    }

    /**
     * @desc Función que cambia el estado de la variable cargando, por el
     * parametro que recibe o por la varibale actual que posee
     */
    cambioEstadoCargando(estado=null){
        if(typeof estado == 'boolean'){
            this.cargando=estado;
        }else{
            this.cargando=!this.cargando;
        }
    }

}
